export default {
  init() {    
    // JavaScript to be fired on the dashboard page
    $('#budget-form-link').fancybox({
      'showCloseButton': false,
    });

    // set up tooltips
    $('body').tooltip({
      position: {
        my: 'center bottom',
        at: 'center top',
      },
    });



    //console.log('Highcharts 1');
    //console.log(Highcharts);

    // make global, since webpack uses enclosures to scope partials
    window.mhpa = window.mhpa || {};
    window.mhpa.loadAccountData = function() {

      // otherwise load data
      $.ajax({
         url: '/rrtpbillcompare/Servlet?type=invoice-count&account=' + encodeURIComponent($('#account').val()),
         success: function(data) {
         //console.log('invoice-count');
         //console.log('invoice-count ' + data);
         if (data == 'true') {
            //console.log('data is true ');
            $('.bills-off').hide();
         } else {
            //console.log('data is false ');
         }
         },
         cache: false,
         async: false,
      });
      $.ajax({ // Search rrtpbc servlet.java for "is-netmeter" to find corresponding java code
         url: '/rrtpbillcompare/Servlet?type=is-netmeter&account=' + encodeURIComponent($('#account').val()),
         success: function(data) {
         if (data == 'rider1') { // user is net-metering participant (1)
            $('.net-meter-off').hide();
            $('.net-meter-on').show();
            $('.community-generation').hide();
            $('.rider-5').hide();
            $('.ccb-nm').show();
            $('.ccb').hide();
         } else if (data == 'rider19') { // user is net-metering && community generation (19)
            $('.net-meter-off').hide();
            $('.net-meter-on').show();
            $('.community-generation').show();
            $('.rider-5').hide();
            $('.ccb-nm').show();
            $('.ccb').hide();
         } else if (data == 'rider9') { // user is standard && community generation (9)
            $('.net-meter-off').hide();
            $('.net-meter-on').hide(); // ?
            $('.community-generation').show();
            $('.rider-5').hide();
            $('.ccb-nm').show();
            $('.ccb').hide();
         } else if (data == 'rider5') { // user is standard && community generation (9)
            $('.net-meter-off').hide();
            $('.net-meter-on').hide(); // ?
            $('.community-generation').hide();
            $('.rider-5').show();
            $('.ccb-nm').show();
            $('.ccb').hide();
         } else { //user is standard
            //$('.dashboard-box').attr('style','max-width: 418px');
            $('.net-meter-off').show();
            $('.net-meter-on').hide();
            $('.community-generation').hide();
            $('.net-meter-on').hide();
            $('.rider-5').hide();
            $('.ccb-nm').hide();
            $('.ccb').show();
         }
         },
         cache: false,
         async: false,
      });

      function getTCType() {
         $.ajax({
         url: '/rrtpbillcompare/Servlet?type=rrtp-enroll-check-bill-protection&account=' + encodeURIComponent($('#account').val()),
         context: document.body,
         success: function(data) {
            if (data == 'Risk-Free Offer') {
               $('#bp-data').show().css('display', 'block');
            } else {
               $('#bp-data').hide().css('display', 'none');
            }
         },
         });
      }
      getTCType();

      $.get('/rrtpbillcompare/Servlet?type=has-base-data&account=' + encodeURIComponent($('#account').val()), function(data) {
        if (data.indexOf('net-metered') >= 0) {
          $.fancybox({
            href: '#net-metered',
          });
        } else {
          $('.main-wrap').show();
        }
      });
      $.ajaxSetup({
        timeout: 90000,
      });
      // otherwise load data
      $.getJSON('/rrtpbillcompare/Servlet?type=savings-box&account=' + encodeURIComponent($('#account').val()), function(json) {
        // console.log(json);
        if (json.numbills == undefined) {
          json.numbills = 'NA';
        }
        if (json.total_savings == undefined) {
          json.total_savings = 'NA';
        }
        if (json.total_supply_savings_pc == undefined) {
          json.total_supply_savings_pc = 'NA';
        }
        $('#savings-box #numbills').text(json.numbills);
        $('#savings-box #amount').text('$' + json.total_savings);
        $('#savings-box #percent').text(json.total_supply_savings_pc + '%');
        $('#datesince').text(json.since);
        if (Number(json.total_savings) < 0) {
          $('#savings-box #amount').prepend('<img src="/wp-content/themes/rrtp/dist/images/2023-mhpa-css-arrow-down.svg" class="savings-arrow"  alt="Red Arrow Pointing Down" />');
        } else {
          $('#savings-box #amount').prepend('<img src="/wp-content/themes/rrtp/dist/images/2023-mhpa-css-arrow-up.svg" class="savings-arrow"  alt="Green Arrow Pointing Up" />');
        }
        if (Number(json.total_supply_savings_pc) < 0) {
          $('#savings-box #percent').prepend('<img src="/wp-content/themes/rrtp/dist/images/2023-mhpa-css-arrow-down.svg" class="savings-arrow"  alt="Red Arrow Pointing Down" />');
        } else {
          $('#savings-box #percent').prepend('<img src="/wp-content/themes/rrtp/dist/images/2023-mhpa-css-arrow-up.svg" class="savings-arrow"  alt="Green Arrow Pointing Up" />');
        }
      });

      // program-overview-chart
      $.getJSON('/rrtpbillcompare/Servlet?type=program-overview-chart&account=' + encodeURIComponent($('#account').val()), function(json) {

        json.chartData = json.chartData.replace(/x:/g, '"x":').replace(/y:/g, '"y":').replace(/color/g, '"color"').replace(/25a3c1/g, '3a5cff').replace(/\'/g, '"').replace(/\s+/g, '');
        //console.log('program-overview-chart json');
        //console.log(json);

        $('#spinner-program-overview-chart').hide();

        //console.log('Highcharts 2');
        //console.log(Highcharts);

        //console.log('json.chartData');
        //console.log(JSON.parse(json.chartData));

        Highcharts.chart({
          chart: {
            renderTo: 'program-overview-chart',
            spacingTop: 50,
            spacingBottom: 2,
            backgroundColor: 'transparent',
            //height: '250',
            //width: '180px',
            type: 'column',
            description: 'Average cost in kilowatt hours for the past 12 months.',
            style: {
              fontFamily: 'Open Sans Condensed',
            },
          },
          navigation: {
            buttonOptions: {
              verticalAlign: 'top',
              y: -25,
            },
          },
          credits: {
            enabled: false,
          },
          title: {
            text: '',
            align: 'center',
            style: {
              fontSize: '12px',
            },
          },
          xAxis: {
            type: 'datetime',
            minPadding: 0.05,
            maxPadding: 0.05,
            //showFirstLabel: true,
            //categories: eval(json.xAxisCategories),
            lineColor: '#170d67',
            title: {
            //	text: json.xAxis
              style: {
                color: '#170d67',
              },
            },
            //minTickInterval : 3600 * 1000,
            dateTimeLabelFormats: {
              month: '%b',
              week: '%e. %b',
              year: '%B',
              hour: '%l%P',
              day: '%b %e',
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '500',
                fontSize: '0.666667rem',
              },
            },
          },
          yAxis: {
            lineColor: '#170d67',
            gridLineColor: '#170d67',
            title: {
              text: 'Cost in ¢/kWh',
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '500',
                fontSize: '0.666667rem',
              },
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '500',
                fontSize: '0.666667rem',
              },
            },
          },
          legend: {
            itemStyle: {
              fontWeight: 'bold',
              color: '#170d67',
            },
            symbolHeight: '0px',
            padding: 0,
          },
          series: [{
            name: json.xAxis,
            data: JSON.parse(json.chartData),
            index: 1,
          }],
          plotOptions: {
            column: {
              pointWidth: 20,
              stacking: 'normal',
              pointPadding: 3,
              //groupPadding: 0.5
              color: '#170d67',
              borderColor: 'transparent',
            },
            series: {
              events: {
                legendItemClick: function() {
                  return false;
                },
              },
              borderRadius: 0
            },
          },
          tooltip: {
            formatter: function() {
              return '<b>Supply Cost</b><br/><br/>' + Highcharts.dateFormat('%B', this.x) + ': ' + this.y + ' ¢/kWh';
            },
          },
          responsive: {
            rules: [{
              condition: {
                maxWidth: 375
              },
              chartOptions: {
                plotOptions: {
                  column: {
                    pointWidth: 10,
                    stacking: 'normal',
                    pointPadding: 3,
                    //groupPadding: 0.5
                    color: '#170d67',
                    borderColor: 'transparent',
                  },
                  series: {
                    events: {
                      legendItemClick: function() {
                        return false;
                      },
                    },
                    borderRadius: 0
                  },
                },
              }
            }]
          },
        });
      });
      // load user data
      /**
          HP-1151: New icons added on 12/12/2022
       */
      $.getJSON('/rrtpbillcompare/Servlet?type=alerts-container&account=' + encodeURIComponent($('#account').val()), function(json) {
        if (json.daSelSMS == '1' || json.rtSelSMS == '1') {
          $('#da-sms').attr('src', '/wp-content/themes/rrtp/dist/images/2023-mhpa-sms-a.svg');
          $('#da-sms').attr('alt', 'Text alerts are active.');
        } else {
          $('#da-sms').attr('src', '/wp-content/themes/rrtp/dist/images/2023-mhpa-sms-ia.svg');
          $('#da-sms').attr('alt', 'Text alerts are inactive.');
        }
        if (json.daSelEmail == '1' || json.rtSelEmail == '1') {
          $('#da-email').attr('src', '/wp-content/themes/rrtp/dist/images/2023-mhpa-email-a.svg');
          $('#da-email').attr('alt', 'Email alerts are active.');
        } else {
          $('#da-email').attr('src', '/wp-content/themes/rrtp/dist/images/2023-mhpa-email-ia.svg');
          $('#da-email').attr('alt', 'Email alerts are inactive.');
        }
        if (json.daSelPhone == '1') {
          $('#da-phone').attr('src', '/wp-content/themes/rrtp/dist/images/2023-mhpa-phone-a.svg');
          $('#da-phone').attr('alt', 'Phone alerts are active.');
        } else {
          $('#da-phone').attr('src', '/wp-content/themes/rrtp/dist/images/2023-mhpa-phone-ia.svg');
          $('#da-phone').attr('alt', 'Phone alerts are inactive.');
        }
        //$('#lg-status').css('background-image', 'url(/wp-content/themes/rrtp/resources/old-theme/img/Status-INACTIVE.png)');
        //$('#lg-status').attr("alt","Unenrolled.");
        if (json.lgStatus != '') {
          //$('#lg-status').css('background-image', 'url(/wp-content/themes/rrtp/resources/old-theme/img/Status-' + json.lgStatus + '.png)');
          //$('#lg-status').attr("alt","Enrolled.");
          $('.green-text').remove();
          $('.gray-text').remove();
          var displayLGStatus = 'Inactive';
          if(json.lgStatus == 'Enroll'){
            displayLGStatus = 'Pending Enroll';
          }else if(json.lgStatus == 'Pending Enrollment'){
            displayLGStatus = 'Pending Enroll';
         }else if(json.lgStatus == 'Pending AC Cycling'){
            displayLGStatus = 'Inactive';
         }else if(json.lgStatus == 'Pending Device Installation'){
            displayLGStatus = 'Pending Enroll';
         }else if(json.lgStatus == 'Enrolled'){
            displayLGStatus = 'Enrolled';
         }else if(json.lgStatus == 'Setpoint Change Request'){
            displayLGStatus = 'Inactive';
         }else if(json.lgStatus == 'Withdraw'){
            displayLGStatus = 'Pending Inactive';
         }else if(json.lgStatus == 'Withdrawn'){
            displayLGStatus = 'Inactive';
         }else if(json.lgStatus == 'Cancelled'){
            displayLGStatus = 'Inactive';
         } 
            $('#lg-status').append('<p class=\'green-text\'>'+ displayLGStatus +'</p>');
        } else {
          $('.gray-text').remove();
          $('.green-text').remove();
          $('#lg-status').append('<p class=\'gray-text\'>Inactive</p>');
        }
        if (json.lgLevel == '10') {
          $('#lg-10').css('background-image', 'url(/wp-content/themes/rrtp/resources/old-theme/img/10-Green.png)');
          $('#lg-10').attr('alt', 'Enrolled.');
        } else {
          $('#lg-10').css('background-image', 'url(/wp-content/themes/rrtp/resources/old-theme/img/10-Gray.png)');
          $('#lg-10').attr('alt', 'Unenrolled.');
        }
        if (json.lgLevel == '14') {
          $('#lg-14').css('background-image', 'url(/wp-content/themes/rrtp/resources/old-theme/img/14-Green.png)');
          $('#lg-14').attr('alt', 'Enrolled.');
        } else {
          $('#lg-14').css('background-image', 'url(/wp-content/themes/rrtp/resources/old-theme/img/14-Gray.png)');
          $('#lg-14').attr('alt', 'Unenrolled.');
        }
      });
      queryPart2();
      /*
        setTimeout(function(){
          // implemented to ease load on MySQL
            queryPart2();
        }, 1500);

        setTimeout(function(){
          // implemented to ease load on MySQL
          if ($('#current-savings-box #percent').html().trim() == '') {
            window.location = window.location.href;
          }
        }, 15000);
      */
      function queryPart2() {
        /**
         * Savings Detail Panel
         *   red: style="color: #bf2e49"
         *   dark-green: style="color: #007a33"
         *   dark-gray: style="color: #6a737b"
         */
        $.getJSON('/rrtpbillcompare/Servlet?type=current-savings-box&account=' + encodeURIComponent($('#account').val()), function(json) {
          $('#spinner-current-savings-box').hide();
          // console.log("Current Savings Box", json)
          json.chartData = json.chartData.replace(/y:/g, '"y":').replace(/, color/g, ',"color"').replace(/007a33/g, '43bf55').replace(/c50033/g, 'c50033').replace(/\'/g, '"').replace(/\s+/g, '');
          if (Number(json.mySavingsRaw) < 0) {
            if ($('#current-savings-box .savingsItem .savings-arrow').length <= 0) {
              $('#current-savings-box .savingsItem .savings-arrow.arrow-up').remove();
              $('#current-savings-box .savingsItem:not(.average)').prepend('<img src="/wp-content/themes/rrtp/dist/images/2023-mhpa-css-arrow-down.svg" class="savings-arrow arrow-down" alt="Red Arrow Pointing Down" />');
            }
            $('#current-savings-box .savingsItem').css('color', '#3a5cff');
            $('#current-savings-box .savingsItem.average').css('color', '#170d67');
          } else {
            if ($('#current-savings-box .savingsItem .savings-arrow').length <= 0) {
              $('#current-savings-box .savingsItem .savings-arrow.arrow-down').remove();
              $('#current-savings-box .savingsItem:not(.average)').prepend('<img src="/wp-content/themes/rrtp/dist/images/2023-mhpa-css-arrow-up.svg" class="savings-arrow arrow-up" alt="Green Arrow Pointing Up" />');
            }
            $('#current-savings-box .savingsItem').css('color', '#3a5cff');
            $('#current-savings-box .savingsItem.average').css('color', '#170d67');
          }
          $('#current-bill #date-range').text(json.dateRangeRaw);
          $('#current-savings-box .dollarsSavedMonth').text(json.mySavingsRaw);
          $('#current-savings-box .percentSavedMonth').text(json.percentRaw);
          $('#current-savings-box .avgSavings').text(json.averageSavingsDispRaw);
          /*
          Highcharts.chart('current-savings-box-chart',{
            lang: {
              accessibility: {
                chartContainerLabel: 'Current Supply Savings Chart: Left bar shows '+json.mySavingsDisp.replace(/<span class='cents'>/g,'.').replace(/<span class='\w+'>/g,'').replace(/<\/span>/g,'')+' or '+json.percent.replace(/<span class='\w+'>/g,'').replace(/<\/span>/g,'')+' saved or spent this month. Right bar shows '+json.averageSavingsDisp.replace(/<span class='\w+'>/g,'').replace(/<\/span>/g,'')+' average participant savings.',
              }
            },
            chart: {
              type: 'column',
              spacing: [5, 2, 2, 2],
              backgroundColor: 'transparent',
            },
            exporting: {
              enabled: false,
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            title: {
              text: '',
            },
            xAxis: {
              title: {
                text: '',
              },
              minorTickLength: 0,
              tickLength: 0,
              gridLineWidth: 0,
              lineColor: 'transparent',
              minorGridLineWidth: 0,
              labels: {
                enabled: false,
              },
            },
            yAxis: {
              title: {
                text: '',
              },
              minorTickLength: 0,
              tickLength: 0,
              gridLineWidth: 0,
              lineColor: 'transparent',
              gridLineColor: '#170d67',
              minorGridLineWidth: 0,
              labels: {
                enabled: false,
              },
            },
            tooltip: {
              enabled: false,
            },
            plotOptions: {
              column: {
                pointWidth: 20,
                stacking: 'normal',
                borderWidth: 0,
              },
            },
            series: [{
              data: JSON.parse(json.chartData),
            }],
            responsive: {
              rules: [{
                condition: {
                  maxWidth: 500
                },
                chartOptions: {
                  plotOptions: {
                    pointWidth: 10,
                    stacking: 'normal'
                  }
                }
              }]
            },
          });
         */
        });


        /**
         * Savings Detail Panel
         */
        /*
        $.getJSON('/rrtpbillcompare/Servlet?type=current-savings-box&account=' + $('#account').val(), function(json) {
          $('#spinner-current-savings-box').hide();
          json.chartData = json.chartData.replace(/y:/g, '"y":').replace(/, color/g, ',"color"').replace(/\'/g, '"').replace(/\s+/g, '');
          if (Number(json.percentRaw) < 0) {
            //$('#current-savings-box .savingsItem:not(.average)').prepend('<img src="/wp-content/themes/rrtp/dist/images/2023-mhpa-css-arrow-down.svg" class="savings-arrow"  alt="Red Arrow Pointing Down" />');
            $('#current-savings-box .savingsItem').css('color', '#3a5cff');
            $('#current-savings-box .savingsItem.average').css('color', '#170d67');
          } else {
            //$('#current-savings-box .savingsItem:not(.average)').prepend('<img src="/wp-content/themes/rrtp/dist/images/2023-mhpa-css-arrow-up.svg" class="savings-arrow"  alt="Green Arrow Pointing Up" />');
            $('#current-savings-box .savingsItem').css('color', '#3a5cff');
            $('#current-savings-box .savingsItem.average').css('color', '#170d67');
          }
          $('#current-bill #date-range').html(json.dateRange);
          $('#current-savings-box .amount').html(json.mySavingsDisp);
          $('#current-savings-box .percent').html(json.percent);
          $('#current-savings-box #average').html(json.averageSavingsDisp);
          Highcharts.chart('current-savings-box-chart', {
            chart: {
              type: 'column',
              spacing: [5, 2, 2, 2],
              backgroundColor: 'transparent',
            },
            exporting: {
              enabled: false,
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            title: {
              text: '',
            },
            xAxis: {
              title: {
                text: '',
              },
              minorTickLength: 0,
              tickLength: 0,
              gridLineWidth: 0,
              lineColor: 'transparent',
              minorGridLineWidth: 0,
              labels: {
                enabled: false,
              },
            },
            yAxis: {
              title: {
                text: '',
              },
              minorTickLength: 0,
              tickLength: 0,
              gridLineWidth: 0,
              lineColor: 'transparent',
              minorGridLineWidth: 0,
              labels: {
                enabled: false,
              },
            },
            tooltip: {
              enabled: false,
            },
            plotOptions: {
              column: {
                pointWidth: 20,
                borderWidth: 0,
                borderColor: 'transparent',
              },
            },
            series: [{
              data: JSON.parse(json.chartData),
            }],
          });
        });
        */
        $.getJSON('/rrtpbillcompare/Servlet?type=comparison-grid&account=' + encodeURIComponent($('#account').val()), function(json) {
          // console.log("comparison grid: " + json);
          $('#spinner-comparison-grid').hide();
          $('#comparison-grid #electricity-supply-charge td:eq(1)').text(json.electricitySupplyChargeSavings);
          $('#comparison-grid #renewable-community-supply-credit td:eq(1)').text(json.renewableCommunitySupplyCreditSavings);
          $('#comparison-grid #transmission-services-charge td:eq(1)').text(json.transmissionServicesSavings);
          $('#comparison-grid #capacity-charge td:eq(1)').text(json.capacityChargeSavings);
          $('#comparison-grid #purchased-electricity-adjustment td:eq(1)').text(json.purchasedElectricityAdjustmentSavings);
          $('#comparison-grid #misc-procurement td:eq(1)').text(json.miscProcurementChargeSavings);
	       $('#comparison-grid #monthly-gen-total-usage td:eq(1)').text(json.hourlyGenerationCreditSavings);
          // ADD TOTALS HERE
          $('#comparison-grid #total td:eq(1)').text(json.totalSavings);
          $('#comparison-grid #nm-hp-savings td:eq(1)').text(json.netmeteringcredithpSavings);
          $('#comparison-grid #nm-credit-savings td:eq(1)').text(json.netmeteringcreditsSavings);
        });
        $.getJSON('/rrtpbillcompare/Servlet?type=current-charges-chart&account=' + encodeURIComponent($('#account').val()), function(json) {
          //console.log(json);
          $('#spinner-current-charges-chart').hide();
          $('#viewDetails').attr('href', '/bc-savings-detail/?account=' + encodeURIComponent($('#account').val()) + '&date=' + encodeURIComponent(json.date));
          var total = '$' + json.currentCharges;
          var griddata = [{
              name: 'Supply',
              y: Number(json.supply),
              color: '#3a5cff',
            }, {
              name: 'Delivery',
              y: Number(json.delivery),
              color: '#170d67',
            }, {
              name: 'Taxes & Fees',
              y: Number(json.taxes),
              color: '#6e06c1',
            }],
            chart = Highcharts.chart({
              chart: {
                renderTo: 'current-charges-chart',
                backgroundColor: 'transparent',
                //height: '180px',
                //width: '180px',
                //plotBackgroundColor: '#e8e8ea',
                plotBorderWidth: 0,
                plotShadow: false,
              },
              accessibility: {
                description: 'Breakdown of current charge between delivery, supply, and taxes & fees.',
              },
              credits: {
                enabled: false,
              },
              title: {
                text: '<span class="title-text" id="charge-text">Total Charge</span> <br /><span class="title-text" id="total-text">' + total + '</span>',
                align: 'center',
                verticalAlign: 'middle',
                style: {
                  color: '#170d67',
                  fontSize: '36px!important',
                  fontWeight: 'bold',
                  fontFamily: 'Open Sans Condensed',
                  lineHeight: '22px',
                },
                y: 15,
              },
              tooltip: {
                //pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                pointFormat: '<b>${point.y:.2f}</b>',
              },
              plotOptions: {
                pie: {
                  size: 115,
                  dataLabels: {
                    enabled: true,
                    distance: 0,
                    style: {
                      fontFamily: 'Open Sans',
                      fontWeight: 'normal',
                      letterSpacing: '.75',
                      fontSize: '14px',
                      color: '#170d67',
                      textShadow: '0',
                      textOutline: 'none',
                    },
                  },
                  //  center: ['50%', '75%']
                },
              },
              series: [{
                type: 'pie',
                name: 'Current Charges',
                innerSize: '80%',
                data: griddata,
              }],
            });
          // Render the circle
          chart.renderer.circle('100%', '100%', '100px').attr({
            fill: 'transparent',
          }).add();
        });
        // REAL TIME USAGE
        // check for if acct has smart meter
        $.get('/rrtpbillcompare/Servlet?type=had-smart-meter&account=' + $('#account').val(), function(data) {
          if (data == 'true') {
            $('#usage').show();
          }
        });
      }
    };

    // save budget info
    $('#budget-form :button').click(function() {
      $('#accountBudget').val($('#account').val());
      // validate
      if ($.isNumeric($('#budgetInput').val())) {
        $.post('/rrtpbillcompare/Servlet?activity=budget-form-submit', $('#budget-form').serialize()).done(function(data) {
          $('#budget-amount').html($('#budgetInput').val());
          $.fancybox.close();
          alert('Your budget has been updated.');
          mhpa.loadAccountData();
        });
      } else {
        alert('Please specify a number.');
      }
    });

    mhpa.loadAccountData();

  },
  finalize() {
    // JavaScript to be fired on the dashboard page, after the init JS
  },
};
